// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"3f8d9f88","48":"2746c758","213":"7765543b","403":"2d6051f7","491":"562791cf","492":"e5b8b10f","585":"3b7f4ef8","683":"aa58702d","940":"ac9aba07","942":"a8ca664b","990":"1d1084e1"}[chunkId] + ".chunk.js";
};